// Core
import React, { useState, useEffect } from "react";

function Question(props) {
	const { id, question, top_text, type, options, bottom_text, routes } = props.data;
	const { newTarget } = props;

	const [optionsArray, setOptionsArray] = useState([]);

	useEffect(() => {
		if (!optionsArray.length) {
			newTarget("");
		} else if (optionsArray.length === 1) {
			var el = document.querySelector(`[data-index="${optionsArray[0]}"]`);
			newTarget(el.dataset.target);
		} else {
			newTarget(routes(optionsArray));
		}
	}, [optionsArray]);

	const handleOptions = (e) => {
		if (type === "radio") {
			newTarget(e.target.dataset.target);
		} else if (type === "checkbox") {
			var idx = e.target.dataset.index;

			var newOptionsArray = optionsArray.includes(idx)
				? optionsArray.filter((option) => option !== idx)
				: [...optionsArray, idx];

			setOptionsArray(newOptionsArray);
		}
	};

	return (
		<>
			<h4 dangerouslySetInnerHTML={{ __html: question }}></h4>
			<p dangerouslySetInnerHTML={{ __html: top_text }}></p>
			{options.map((option) => {
				return (
					<label className="questionBox" key={id + "_" + option.id}>
						<span dangerouslySetInnerHTML={{ __html: option.text }}></span>
						<input
							type={type}
							name={id + "-option"}
							data-index={option.id}
							data-target={option.target}
							onChange={(e) => {
								handleOptions(e);
							}}
						/>
						<span className={"checkmark " + type}></span>
					</label>
				);
			})}
			<p dangerouslySetInnerHTML={{ __html: bottom_text }}></p>
		</>
	);
}

export default Question;
